export default {
    username: 'ชื่อผู้ใช้',
    usernamePlaceHolder: 'ระบุชื่อผู้ใช้',
    password: 'รหัสผ่าน',
    passwordPlaceHolder: 'ระบุรหัสผ่าน',
    login: 'เข้าสู่ระบบ',
    forgotPassword: 'ลืมรหัสผ่าน',
    usernameRequired: 'ระบุชื่อผู้ใช้',
    passwordRequired: 'ระบุรหัสผ่าน'
}
